import { STORAGE_KEYS } from "@/constants/storageKeys";

const getSessionStorage = () => {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch (_) {
    return null;
  }
};

const normalizePayload = (payload) => (
  payload && typeof payload === "object" && !Array.isArray(payload) ? payload : null
);

export const writeFlowPrefill = (key, payload) => {
  const storage = getSessionStorage();
  const normalized = normalizePayload(payload);
  if (!storage || !normalized) return false;
  try {
    storage.setItem(key, JSON.stringify(normalized));
    return true;
  } catch (_) {
    return false;
  }
};

export const readAndClearFlowPrefill = (key) => {
  const storage = getSessionStorage();
  if (!storage) return null;
  try {
    const raw = storage.getItem(key);
    storage.removeItem(key);
    return raw ? normalizePayload(JSON.parse(raw)) : null;
  } catch (_) {
    try {
      storage.removeItem(key);
    } catch (_) {
      // Ignore private-mode/session-storage failures.
    }
    return null;
  }
};

export const clearFlowPrefill = (key) => {
  const storage = getSessionStorage();
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch (_) {
    // Ignore private-mode/session-storage failures.
  }
};

export const WORKORDER_CREATE_PREFILL_KEY = STORAGE_KEYS.WORKORDER_CREATE_PREFILL;
export const CONTRACT_CREATE_PREFILL_KEY = STORAGE_KEYS.CONTRACT_CREATE_PREFILL;
